type MockModeState = {
    active: boolean
    scenario: Record<string, unknown> | null
}

export function useMockMode() {
    const state = useState<MockModeState>('mock-mode', () => ({
        active: false,
        scenario: null,
    }))

    const active = computed(() => state.value.active)
    const scenario = computed(() => state.value.scenario)

    const refresh = async () => {
        try {
            const data = await $fetch<MockModeState>('/api/e2e/mock-session')
            state.value = {
                active: data.active,
                scenario: data.scenario ?? null,
            }
        } catch {
            state.value = { active: false, scenario: null }
        }
    }

    const deactivate = async () => {
        await $fetch('/api/e2e/mock-session', {
            method: 'POST',
            body: { scenario: null },
        })

        state.value = { active: false, scenario: null }

        // Full-page reload so SSR re-runs without the mock cookie,
        // clearing any mock site data from the global store.
        await navigateTo('/_e2e', { external: true })
    }

    return {
        active,
        scenario,
        refresh,
        deactivate,
    }
}
